var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDateGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Documentation-&-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/SelectDate",
    fill: "#C3CBD7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0631579,1.74006445 L13.1873684,1.74006445 L13.1873684,0.792696026 C13.1873684,0.367346939 12.8463158,0 12.4105263,0 C11.9747368,0 11.6526316,0.367346939 11.6526316,0.792696026 L11.6526316,1.74006445 L6.34736842,1.74006445 L6.34736842,0.792696026 C6.34736842,0.367346939 6.00631579,0 5.57052632,0 C5.13473684,0 4.79368421,0.348012889 4.79368421,0.792696026 L4.79368421,1.74006445 L2.93684211,1.74006445 C1.30736842,1.74006445 0,3.09344791 0,4.73684211 L0,15.0032223 C0,16.6659506 1.32631579,18 2.93684211,18 L15.0631579,18 C16.6926316,18 18,16.6466165 18,15.0032223 L18,4.73684211 C18,3.09344791 16.6736842,1.74006445 15.0631579,1.74006445 Z M2.93684211,3.30612245 L4.81263158,3.30612245 L4.81263158,4.25349087 C4.81263158,4.67883996 5.15368421,5.0461869 5.58947368,5.0461869 C6.02526316,5.0461869 6.36631579,4.69817401 6.36631579,4.25349087 L6.36631579,3.30612245 L11.6715789,3.30612245 L11.6715789,4.25349087 C11.6715789,4.67883996 12.0126316,5.0461869 12.4484211,5.0461869 C12.8842105,5.0461869 13.2252632,4.69817401 13.2252632,4.25349087 L13.2252632,3.30612245 L15.0631579,3.30612245 C15.84,3.30612245 16.4652632,3.94414608 16.4652632,4.73684211 L16.4652632,7.05692803 L1.53473684,7.05692803 L1.53473684,4.73684211 C1.53473684,3.94414608 2.16,3.30612245 2.93684211,3.30612245 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDateGrey);
export default __webpack_public_path__ + "static/media/icon-date-grey.122c1ea6c266fccdad28a1e8ffbd97f5.svg";
export { ForwardRef as ReactComponent };